import Vue from 'vue'
import { validationMixin } from 'vuelidate'

export default {

    mixins: [validationMixin],

    data: function() {
    
        return {
            is: {
                loading: true,
                failed: false,
                saving: false,
                deleting: false,
                initialised: false
            },
            redirect: {
                new: false,
                save: false,
                delete: false
            },
            model: {},
            original: {}
        }
    
    },

    created: function() {
    
        this.load()
    
    },

    computed: {

        canSave: function() {

            return this.isValid && this.isDirty && !this.is.loading && !this.is.saving && !this.is.deleting

        },

        canDelete: function() {
        
            return !this.isNew && !this.is.saving

        },
    
        isValid: function() {

			return !this.$v.$invalid

		},

		isDirty: function() {

			return !this.$_.isEqual(this.model, this.original)

		},

        isNew: function() {

			return this.$route.params.id === 'create'

		},

        getFlatAPI: function() {
        
            return (this.$_.isArray(this.api)) ? this.api.join('/') : this.api
        
        }

    },

    watch: {

		model: {

			deep: true,
			handler: function() {

				this.$v.$touch()

			}

		}

	},

    methods: {

        buildModel: function(model) {
        
            model = this.$util.copy(model)

            this.$_.each(this.modelExtend, function(value, key) {
            
                model[key] = value

            })

            return model

        },
    
        load: function() {
        
            this.$api.get([this.getFlatAPI, this.$route.params.id]).then(function(json) {

                Vue.set(this, 'original', this.buildModel(json.model))
                Vue.set(this, 'model', this.buildModel(json.model))

                this.is.loading = false

                if(this.afterLoad) this.afterLoad(json)

                if(!this.is.initialised) {
                
                    this.is.initialised = true
                    this.$emit('ready')
                
                }
            
            }.bind(this), function() {

                this.is.loading = false
                this.is.failed = true
            
            }.bind(this))
        
        },

        onDeleteClick: function() {
        
            if (!this.is.saving) {

                this.is.deleting = true

                this.$api.delete([this.getFlatAPI, this.$route.params.id]).then(function() {

                    this.$success('Successfully deleted.')

                    this.$router.push((this.$_.isObject(this.redirect.delete)) ? this.redirect.delete : {
                        name: this.redirect.delete
                    })

                    this.is.deleting = false
                
                }.bind(this), function() {

                    this.is.deleting = false
                    this.is.failed = true

                    this.$failure('Sorry, something went wrong. Please try again.')
                
                }.bind(this))

            }

        },

        onSaveClick: function() {
        
            if (!this.is.saving) {

                this.is.saving = true

                this.$api[(this.isNew) ? 'post' : 'put']([this.getFlatAPI, this.$route.params.id], this.model).then(function(json) {

                    Vue.set(this, 'original', this.buildModel(json.model))
                    Vue.set(this, 'model', this.buildModel(json.model))

                    this.is.saving = false

                    this.$success((this.isNew) ? 'Successfully created.' : 'Successfully saved.')

                    if (this.redirect.new && this.isNew) this.$router.push((this.$_.isObject(this.redirect.new)) ? this.redirect.new : {
                        name: this.redirect.new
                    })

                    if (this.redirect.save && !this.isNew) this.$router.push((this.$_.isObject(this.redirect.save)) ? this.redirect.save : {
                        name: this.redirect.save
                    })

                    if (!this.redirect.new && this.isNew) this.$router.replace({
                        params: {
                            id: this.model.id
                        }
                    })
                
                }.bind(this), function() {

                    this.is.saving = false
                    this.is.failed = true

                    this.$failure('Sorry, something went wrong. Please try again.')
                
                }.bind(this))

            }
        
        }
        
    }

}